// extracted by mini-css-extract-plugin
module.exports = {"wrap":"dj-z","heading":"ej-z"};